<template>
  <div class="h-1.5 min-h-[0.375rem] w-full overflow-hidden bg-slate-200">
    <div class="h-full rounded-r-full bg-brand transition-all duration-500" :style="{ width: currentWidth }"></div>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
      default: 100
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    currentWidth() {
      return `${this.index * this.stepSize}%`
    },
    stepSize() {
      return 100 / this.count
    }
  }
}
</script>
